import axios from './axiosInstance';

export const addEvent = async (eventData) => {
  try{
    const response = await axios({
      url : '/add-event',
      method : 'POST',
      data : eventData
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : error.response?.data || null,
      error : error
    }
  }
}

export const listEvents = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-events',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : error.response?.data || null,
      error : error
    }
  }
}

export const updateEvent = async ({
  data,
  id
}) => {

  try{
    const response = await axios({
      url : `/update-event/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : error.response?.data || null,
      error : error
    }
  }
}

export const deleteEvent = async ({
  id
}) => {
  try{
    const response = await axios({
      url : `/delete-event/${id}`,
      method : 'DELETE'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : error.response?.data || null,
      error : error
    }
  }
}

export const getEvent = async ({
  id
}) => {

  try{
    const response = await axios({
      url : `/get-event/${id}`,
      method : 'GET'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : error.response?.data || null,
      error : error
    }
  }
}

export const syncEvent = async ({ id }) => {
  try {
    const response = await axios({
      url: `/sync-event/${id}`,
      method: 'POST'
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: error.response?.data || null, error };
  }
};

export const getEventIntegrationStatus = async () => {
  try {
    const response = await axios({
      url: '/event-integration-status',
      method: 'GET'
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: error.response?.data || null, error };
  }
};
